<template>
  <v-card flat tile @click="$emit('click')" height="100%" color="grey lighten-5">
    <v-img :src="car.images.main.src" aspect-ratio="1.2"></v-img>

    <v-card-title class="d-flex flex-column align-start">
      <price-sheet :price="car.price"></price-sheet>
      <div class="text-subtitle-1 font-weight-medium">{{ car.title }}</div>
      <status-tag>{{ car.status }}</status-tag>
    </v-card-title>

    <v-card-text>
      <brand-chip :to="`/brand/${car.brandLogicalName}`" class="mr-2 my-1">{{
        car.brand
      }}</brand-chip>
      <brand-chip v-if="car.class" class="mr-2 my-1">{{ car.class }}</brand-chip>
      <brand-chip v-if="car.model" class="my-1">{{ car.model }}</brand-chip>
    </v-card-text>
  </v-card>
</template>

<script>
import BrandChip from "./BrandChip.vue"
import PriceSheet from "./PriceSheet.vue"
import StatusTag from "./StatusTag.vue"

export default {
  props: ["car"],

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown
    },
  },

  // methods: {
  //   call() {
  //     window.open("tel:900300400")
  //   },
  // },
  components: {
    BrandChip,
    PriceSheet,
    StatusTag,
  },
}
</script>
